module.exports = __webpack_public_path__ + "img/4.4dcb4543.jpg";